function logActionRequired(message) {
  if (typeof process !== 'undefined' && process.env?.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(message);
  }
}
function logActionRequiredIf(message, conditional) {
  if (conditional) {
    logActionRequired(message);
  }
}

export { logActionRequired, logActionRequiredIf };
//# sourceMappingURL=logActionRequired.mjs.map
